import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function RequestAccessLanding() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const gateId = queryParams.get('gateId');

  useEffect(() => {
    // Attempt to open the app automatically
    if (gateId) {
      // Construct the deep link URL (same as the one in the QR code, but with a custom scheme if needed, 
      // or rely on Universal Links which is what we are doing here by visiting this URL)
      // Since we are already ON the Universal Link URL in the browser, it means the app didn't catch it.
      // So we fallback to store links.
    }
  }, [gateId]);

  const appStoreLink = "https://apps.apple.com/no/app/bifrostkey/idPLACEHOLDER"; // Replace with actual ID
  const playStoreLink = "https://play.google.com/store/apps/details?id=com.bifrostkey.app"; // Replace with actual ID

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh', 
      padding: '20px', 
      textAlign: 'center',
      fontFamily: 'sans-serif' 
    }}>
      <h1>BifrostKey</h1>
      <p>For å åpne denne porten, må du bruke BifrostKey-appen.</p>
      
      <div style={{ marginTop: '40px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <a href={appStoreLink} style={{ 
          padding: '15px 30px', 
          backgroundColor: '#007AFF', 
          color: 'white', 
          textDecoration: 'none', 
          borderRadius: '10px',
          fontWeight: 'bold'
        }}>
          Last ned for iPhone
        </a>
        
        <a href={playStoreLink} style={{ 
          padding: '15px 30px', 
          backgroundColor: '#00832d', 
          color: 'white', 
          textDecoration: 'none', 
          borderRadius: '10px',
          fontWeight: 'bold'
        }}>
          Last ned for Android
        </a>
      </div>

      <p style={{ marginTop: '40px', color: '#666' }}>
        Har du allerede appen? <br/>
        <a href={`bifrostkey://request-access?gateId=${gateId}`}>Prøv å åpne den her</a>
      </p>
    </div>
  );
}

export default RequestAccessLanding;
